import React, {useState} from 'react';

import {useUI} from 'coreHooks';

import CMSPopup from 'brandComponents/CMSPopup';
import AddPaymentCardPopup from 'brandComponents/popups/AddPaymentCardPopup';
import AddressPopup from 'brandComponents/popups/AddressPopup';
// eslint-disable-next-line max-len
import CountryConfirmRedirectPopup from 'brandComponents/popups/CountryConfirmRedirectPopup/CountryConfirmRedirectPopup';
import CountryRedirectPopup from 'brandComponents/popups/CountryRedirectPopup';
import EditProfilePopup from 'brandComponents/popups/EditProfilePopup';
import NewPasswordPopup from 'brandComponents/popups/NewPasswordPopup';
import NotifyMePopup from 'brandComponents/popups/NotifyMePopup';
import SavedCreditCardPopup from 'brandComponents/popups/SavedPaymentCardPopup';
import ShareProductByEmailPopup from 'brandComponents/popups/ShareProductByEmailPopup';
import ShareProductPopup from 'brandComponents/popups/ShareProductPopup';

const PopupsContainer = () => {
	const openedPopupIds = useUI('openedPopupIds') || [];
	const [loadedPopups, setLoadedPopups] = useState({});

	const isPopupOpen = (popupId: string): boolean => {
		const isOpen = openedPopupIds.indexOf(popupId) !== -1;

		if (isOpen && !loadedPopups[popupId]) {
			setLoadedPopups(
				Object.assign({}, loadedPopups, {
					[popupId]: true,
				}),
			);
		}

		return isOpen;
	};
	const isPopupInPage = (popupId: string): boolean => isPopupOpen(popupId) || loadedPopups[popupId];

	return (
		<>
			{isPopupInPage('address') && <AddressPopup />}
			{isPopupInPage('myAccount.personalData') && <EditProfilePopup />}
			{isPopupInPage('myAccount.addCreditCard') && <AddPaymentCardPopup />}
			{isPopupInPage('myAccount.savedCreditCard') && <SavedCreditCardPopup />}
			{isPopupInPage('newsletter') && <CMSPopup id="Newsletter" />}
			{isPopupInPage('newPassword') && <NewPasswordPopup />}
			{isPopupInPage('shipping') && <CMSPopup id="Shipping" />}
			{isPopupInPage('returns') && <CMSPopup id="Returns" />}
			{isPopupInPage('exclusive') && <CMSPopup id="Exclusive" />}
			{isPopupInPage('productBanned') && <CMSPopup id="ProductBannedPopup" />}
			{isPopupInPage('shareProduct') && <ShareProductPopup />}
			{isPopupInPage('shareProductByEmail') && <ShareProductByEmailPopup />}
			{isPopupInPage('preorder') && <CMSPopup id="Preorder" />}
			{isPopupInPage('countryConfirmRedirect') && <CountryConfirmRedirectPopup />}
			<NotifyMePopup />
			<CountryRedirectPopup />
		</>
	);
};

export default React.memo(PopupsContainer);
